module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp23_8003.612e8162.png";